import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { useMemo as y } from "react";
import { useTranslation as C } from "react-i18next";
import { isObject as x, isDefined as D, isNumberString as A, formatDecimal as I, formatCurrency as N } from "@perxis-auto/shared";
import { useFinalResult as L, useStages as R } from "@perxis-auto/trade-in-sdk";
import { Button as g } from "@perxis-auto/ui-kit/lib/components/Button";
import { Row as s, Col as r } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Icon as T } from "@perxis-auto/ui-kit/lib/components/Icon";
import { Typography as n } from "@perxis-auto/ui-kit/lib/components/Typography";
import { ANALYTIC_EVENT_SAVE_RESULT as $, BUTTON_ID_SAVE_RESULT as U, EVENT_BUTTON_CLICKED as V } from "../../../shared/config/events.js";
import { useAppContext as B } from "../../../shared/lib/app/context/appContext.js";
import { sendEvent as j } from "../../../shared/lib/event/sendEvent.js";
import { SUCCESS_TABLE_FIELD_IDS as w } from "../lib/config/index.js";
function X() {
  var u, h, f, v;
  const { data: t } = L(), { service: m } = R(), { onReset: b, onSuccess: d } = B(), { t: c } = C(), p = `${((h = (u = t.brand) == null ? void 0 : u.value) == null ? void 0 : h.text) || ""} ${((v = (f = t.model) == null ? void 0 : f.value) == null ? void 0 : v.text) || ""}`.trim(), S = y(() => w.map((l) => {
    var _;
    const a = t[l];
    if (!a || !x(a) || !D(a.value))
      return;
    let o;
    return x(a.value) ? o = (_ = a.value) == null ? void 0 : _.text : A(a.value) ? o = I(Number(a.value)) : o = a.value, {
      key: l,
      label: a.label,
      value: o
    };
  }).filter((l) => !!l), [t]), k = () => {
    j(V, { id: U }, $), d == null || d(t);
  }, E = t.min && t.max ? `${N(Number(t.min), { hasCurrency: !1 })} — ${N(Number(t.max))}` : c("successStage.estimatedPrice.noData");
  return /* @__PURE__ */ i(s, { gutter: [0, "vertical-yellow"], children: [
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(s, { gutter: [0, "vertical-sky"], className: "pa-trade-in-card", children: [
      !!p.length && /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(n.Title, { className: "pa-trade-in-card__title", color: "darkest", level: "h3", children: p }) }),
      /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(s, { gutter: [0, "vertical-green"], children: [
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(s, { className: "pa-trade-in-table", children: S.map((l) => /* @__PURE__ */ i(r, { span: 24, className: "pa-trade-in-table__item", children: [
          /* @__PURE__ */ e(n.Text, { className: "pa-trade-in-table__label", color: "dark", level: "small", children: l.label }),
          /* @__PURE__ */ e(n.Text, { className: "pa-trade-in-table__value", color: "darkest", level: "small", children: l.value })
        ] }, l.key)) }) }),
        /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(s, { gutter: [0, "vertical-purple"], className: "pa-trade-in-price", children: [
          /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(n.Text, { className: "pa-trade-in-price__label", color: "dark-light", level: "main", children: ` ${c("successStage.estimatedPrice.title")}${m != null && m.disclaimer_text ? "*" : ""}` }) }),
          /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ e(n.Text, { className: "pa-trade-in-price__value", color: "darkest", level: "h3", children: E }) })
        ] }) })
      ] }) })
    ] }) }),
    /* @__PURE__ */ e(r, { span: 24, children: /* @__PURE__ */ i(s, { gutter: [16, "vertical-sky"], children: [
      /* @__PURE__ */ e(r, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ e(
        g,
        {
          type: "primary",
          icon: /* @__PURE__ */ e(T, { name: "forward", sticker: "trade-in-instock-save-result-icon" }),
          onClick: k,
          children: c("successStage.save")
        }
      ) }),
      /* @__PURE__ */ e(r, { xs: { flex: "0 0 100%" }, sm: { flex: "none" }, children: /* @__PURE__ */ e(
        g,
        {
          type: "ghost",
          icon: /* @__PURE__ */ e(T, { name: "refresh", sticker: "trade-in-instock-refresh-icon" }),
          onClick: b,
          children: c("successStage.reset")
        }
      ) })
    ] }) })
  ] });
}
export {
  X as SuccessStage
};
